export const theme = {
  colors: {
    primary: "#1B4332",
    secondary: "#84a98c",
    body: "#2f3e46",
    over: "#52b788",
    background1: "#cad2c5",
    background2: "#cad2c5",
    iconsBackground: "#D7FFF1",
  },
};
